
import axios from 'axios';
import AppConfig from '../constants/AppConfig'

const instance = axios.create({
    baseURL: AppConfig.janeAPI,
    headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('AUTH_TOKEN')}`,
        'X-Requested-With': 'XMLHttpRequest',
    }
});


instance.interceptors.request.use(function (config) {
    const token = `Bearer ${sessionStorage.getItem('AUTH_TOKEN')}`;
    if(token) {
        config.headers.Authorization = token;
        if(sessionStorage.getItem('CURRENT_LANGUAGE')){
            config.params ={ ...config.params,...{language_id:sessionStorage.getItem('CURRENT_LANGUAGE')}};
        }
    }
    // Do something before request is sent
    return config;
}, function (error) {
    console.log(error.reponse.status)
    // Do something with request error
    return Promise.reject(error);
});

export default instance

